









































































































































































































































































































































































































































































































































import Vue from "vue";
import MessageEditor from "../../../components/MessageEditor";
import { ref, computed, onBeforeMount, onMounted } from "@vue/composition-api";
import { countryList } from "../../../helpers/consts";
import {
  orderedTime,
  filterOperatorOptions,
  filterTypeOptions,
} from "../../../helpers/campaignHelpers";
import messagePreviewHelper from "../../../helpers/messagePreviewHelper";
import formatDate from "../../../helpers/formatDate";
import formatScheduleDate from "../../../helpers/formatScheduleDate";
import formatCurrency from "../../../helpers/formatCurrency";
import { filterFriendlyMessage } from "../../../helpers/filterFriendlyMessage";
import formatDiscountMessage from "../../../helpers/formatDiscountMessage";

const required = (value) => !!value || "Required";
const requiredArr = (value) => value.length > 0 || "Required";

export default Vue.extend({
  name: "CampaignEdit",
  components: {
    MessageEditor,
  },
  setup(props, context: any): any {
    const message = ref("{ShopName}: Hi {FirstName}, ");
    const campaignDiscount = ref(null);
    const selectedRecipient = ref(null);
    const displayName = ref("");
    const scheduleOption = ref("now");
    const scheduleDateVal = ref("");
    const scheduleTimeVal = ref("");
    const filters = ref([]);
    const validForm = ref(true);
    const store = computed(() => context.root.$store.state.store);
    const campaignPreview = computed(
      () => context.root.$store.state.campaigns.campaignPreview
    );
    const storeBalance = computed(
      () => context.root.$store.state.shop.storeBalance
    );
    const reviewModal = ref(false);
    const recipientsModal = ref(false);
    const topUpAlertModal = ref(false);
    const renderMessageEditor = ref(false);
    const discountConfiguration = ref(null);

    function handleUpdateMessageEditor({ val, formValid, discount, config }) {
      message.value = val;
      campaignDiscount.value = discount;
      validForm.value = formValid;
      discountConfiguration.value = config;
    }

    function addFilter() {
      const filter = {
        operator: "",
        field: "",
        values: "",
      };

      filters.value.push(filter);
    }

    function resetOperatorAndValue(filter, index) {
      filters.value[index].operator = "";
      filters.value[index].value = "";
    }

    function handleSaveDraft() {
      const valid = context.refs.campaignEditForm.validate();
      validForm.value = valid;
      if (valid) {
        const payload = {
          displayName: displayName.value,
          body: message.value,
          discount: campaignDiscount.value,
          filters: filters.value,
          scheduleDate: null,
          scheduleTime: null,
        };

        if (scheduleOption.value === "later") {
          const scheduleDate = scheduleDateVal.value.split("-");
          payload.scheduleDate = {
            year: scheduleDate[0],
            month: scheduleDate[1],
            day: scheduleDate[2],
          };
          const scheduleTime = scheduleTimeVal.value.split(":");
          const scheduleTimeHours = scheduleTime[0];
          const scheduleTimeMinutes = scheduleTime[1];
          const quietStartTime = {
            hours: parseInt(scheduleTimeHours),
            minutes: parseInt(scheduleTimeMinutes),
            seconds: 0,
            nanos: 0,
          };
          payload.scheduleTime = quietStartTime;
        }

        if (
          context.root.$route.params.campaignId === "new" ||
          context.root.$route.name === "CampaignsDraft"
        ) {
          context.root.$store
            .dispatch("campaigns/createCampaign", payload)
            .then((res) => {
              context.root.$mixpanel.track("Click", {
                Parent: "Campaigns",
                Action: "Create Campaign",
              });
              context.root.$store.dispatch("campaigns/getCampaignPreview", {
                campaignId: res.name.split("/")[3],
              });
              context.root.$router.push(
                `/campaigns/${res.name.split("/")[3]}/edit`
              );
            });
        } else {
          context.root.$store
            .dispatch("campaigns/updateCampaign", {
              payload,
              campaignId: context.root.$route.params.campaignId,
            })
            .then((res) => {
              context.root.$mixpanel.track("Click", {
                Parent: "Campaigns",
                Action: "Update Campaign",
              });
              context.root.$store.dispatch("campaigns/getCampaignPreview", {
                campaignId: res.name.split("/")[3],
              });
            });
        }
      }
    }

    function handleSaveAndSchedule() {
      const valid = context.refs.campaignEditForm.validate();
      validForm.value = valid;
      if (valid) {
        handleSaveDraft();
        reviewModal.value = true;
      }
    }

    const topUpAmount = ref("");

    function confirmSend(forceSend) {
      if (!forceSend) {
        const currentBalance = (
          parseFloat(storeBalance.value.balance.units) +
          storeBalance.value.balance.nanos / 1000000000
        ).toFixed(2);

        const estimatedCost = (
          parseFloat(
            campaignPreview.value.estimatedCost
              ? campaignPreview.value.estimatedCost.units
              : "0"
          ) +
          (campaignPreview.value.estimatedCost
            ? campaignPreview.value.estimatedCost.nanos
            : 0) /
            1000000000
        ).toFixed(2);

        // Check to see if the current balance is less than the estimated cost of the compaign.
        // If true alert the user and prompt them to top up their account before the send it.
        // topUpAlert: false,
        // topUpModal: false,

        if (currentBalance < estimatedCost && !campaignPreview.value.more) {
          const topUpAmountT =
            // @ts-ignore
            Math.ceil((estimatedCost - currentBalance + 1) / 10) * 10;
          (topUpAmount.value = JSON.stringify(topUpAmountT)),
            (topUpAlertModal.value = true);
          return;
        }
      }
      context.root.$store
        .dispatch("campaigns/sendCampaign", {
          campaignId: context.root.$route.params.campaignId,
        })
        .then((res) => {
          context.root.$mixpanel.track("Click", {
            Parent: "Campaigns",
            Action: "Send Campaign",
          });
          reviewModal.value = false;
          context.root.$router.push(
            `/campaigns/${context.root.$route.params.campaignId}/view`
          );
        });
    }

    function cancelReview() {
      reviewModal.value = false;
    }

    onMounted(() => {
      context.root.$store.dispatch("shop/getShippingCountries");
      context.root.$store.dispatch("shop/getExistingDiscounts");
      context.root.$mixpanel.track("Page Load", { Page: "Campaign Edit" });
      if (context.root.$route.params.campaignId === "new") {
        renderMessageEditor.value = true;
        return;
      }
      context.root.$store
        .dispatch("campaigns/getCampaign", {
          campaignId: context.root.$route.params.campaignId,
        })
        .then((res) => {
          displayName.value = res.displayName;
          message.value = res.body;
          if (res.filters) {
            filters.value = res.filters;
          }
          if (res.discount) {
            campaignDiscount.value = res.discount;
          }
          if (res.scheduleDate) {
            const scheduleTime = res.scheduleTime;
            const scheduleDate = res.scheduleDate;
            scheduleOption.value = "later";
            scheduleTimeVal.value =
              (scheduleTime.hours < 10
                ? `0${scheduleTime.hours}`
                : scheduleTime.hours) +
              ":" +
              (scheduleTime.minutes < 10
                ? `0${scheduleTime.minutes}`
                : scheduleTime.minutes);

            scheduleDateVal.value =
              scheduleDate.year +
              "-" +
              (scheduleDate.month < 10
                ? `0${scheduleDate.month}`
                : scheduleDate.month) +
              "-" +
              (scheduleDate.day < 10
                ? `0${scheduleDate.day}`
                : scheduleDate.day);
          }

          renderMessageEditor.value = true;
        });
    });

    function removeFilter(filter, index) {
      filters.value.splice(index, 1);
    }

    const loading = computed(() => context.root.$store.state.loading);

    function handleConfirmTopUp() {
      context.root.$mixpanel.track("Click", {
        Parent: "Campaign Top Up",
        Value: topUpAmount.value,
      });
      context.root.$store
        .dispatch("shop/topUp", {
          amount: topUpAmount.value,
          param: context.root.$route.params.campaignId,
        })
        .then((res) => {
          //
        });
    }

    return {
      menu: false,
      menu2: false,
      handleConfirmTopUp,
      topUpAmount,
      loading,
      removeFilter,
      discountConfiguration,
      campaignPreview,
      renderMessageEditor,
      validForm,
      countryList,
      filters,
      displayName,
      message,
      campaignDiscount,
      handleUpdateMessageEditor,
      handleSaveDraft,
      handleSaveAndSchedule,
      resetOperatorAndValue,
      required,
      requiredArr,
      scheduleOption,
      scheduleDateVal,
      scheduleTimeVal,
      addFilter,
      orderedTime,
      filterOperatorOptions,
      filterTypeOptions,
      messagePreviewHelper,
      store,
      reviewModal,
      recipientsModal,
      topUpAlertModal,
      cancelReview,
      confirmSend,
      formatDate,
      formatScheduleDate,
      formatCurrency,
      filterFriendlyMessage,
      formatDiscountMessage,
      selectedRecipient,
    };
  },
});
